import React from 'react';
import Select from 'react-select';
import { tAgendaActionCustomSelectProps } from '../Agenda.types';
import './CustomSelect.styles.scss';

export default function CustomSelect(
  props: tAgendaActionCustomSelectProps,
): React.ReactElement {
  const { options, defaultOptions } = props;

  return (
    <Select
      classNamePrefix="select"
      className="w-full"
      options={options}
      onChange={(value) => props.onChange(value)}
      defaultValue={defaultOptions}
      isMulti
    />
  );
}
